import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";
import { setLoader } from "./WorkFlowRedux";
import axios from "axios";
import { commonservices } from "../../CommonServices";

export const GetSubscriberProfile = createAsyncThunk(
    "GetSubscriberProfile",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "GET",
                    url:
                        API_URL.BASEURL +
                        API_URL.SUBSCRIBER.GET_SUBSCRIBER_PROFILE +
                        `?subscriberId=${data.id}`,
                    body: {},
                },
                true
            );
            let response = apiResponse(
                false,
                resData,
                data.setSubsciberProfileLoader
            );
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const UpdateSubscriberProfileAPI = createAsyncThunk(
    "UpdateSubscriberProfileAPI",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await axios(
                {
                    method: "PUT",
                    url: API_URL.BASEURL + API_URL.SUBSCRIBER.UPDATE_SUBSCRIBER_PROFILE,
                    data: data,
                    headers: commonservices.getHeadersFromData(),
                },
                true
            );
            let response = apiResponse(true, resData?.data);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const GetSubscriberByPrimaryKey = createAsyncThunk(
    "GetSubscriberByPrimaryKey",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL?.BASEURL +
                        API_URL?.SUBSCRIBER?.GET_SUBSCRIBER_BY_PRIMARY_KEY,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);

            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const BecomeDeveloper = createAsyncThunk(
    "BecomeDeveloper",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "PUT",
                    url: API_URL.BASEURL + API_URL?.SUBSCRIBER?.BECOME_DEVELOPER,
                    body: data,
                },
                false
            );
            let response = apiResponse(true, resData);

            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);
export const BecomeClient = createAsyncThunk(
    "BecomeClient",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "PUT",
                    url: API_URL.BASEURL + API_URL?.SUBSCRIBER?.BECOME_CLIENT,
                    body: data,
                },
                false
            );
            let response = apiResponse(true, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);
export const SubscriberInviteUser = createAsyncThunk(
    "SubscriberInviteUser",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL?.SUBSCRIBER?.SUBSCRIBERINVITEUSER,
                    body: data,
                },
                true
            );
            let response = apiResponse(true, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const SubscriberValidateDeActivate = createAsyncThunk(
    "SubscriberValidateDeActivate",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "GET",
                    url:
                        API_URL.BASEURL +
                        API_URL.SUBSCRIBER.SUBSCRIBERVALIDATEDEACTIVATE + "?checkfor=" + data,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);


const initialState = {
    GetSubscriberProfileData: {
        data: null,
        error: null,
    },
    UpdateSubscriberProfileAPIData: {
        data: null,
        error: null,
    },
    GetSubscriberByPrimaryKeyData: {
        data: null,
        error: null,
    },
    BecomeDeveloperData: {
        data: null,
        error: null,
    },
    BecomeClientData: {
        data: null,
        error: null,
    },
    SubscriberInviteUserData: {
        data: null,
        error: null,
    },
    SubscriberValidateDeActivateData: {
        data: null,
        error: null,
    },
};

const SubscriberSlice = createSlice({
    name: "SubscriberSlice",
    initialState,
    reducers: {
        setSubscriberIdData: (state) => {
            state.GetSubscriberProfileData.data = null;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(GetSubscriberProfile.fulfilled, (state, action) => {
                state.GetSubscriberProfileData.data = action.payload;
            })
            .addCase(GetSubscriberProfile.rejected, (state, action) => {
                state.GetSubscriberProfileData.error = action.error.message;
            })
            .addCase(UpdateSubscriberProfileAPI.fulfilled, (state, action) => {
                state.UpdateSubscriberProfileAPIData.data = action.payload;
            })
            .addCase(UpdateSubscriberProfileAPI.rejected, (state, action) => {
                state.UpdateSubscriberProfileAPIData.error = action.error.message;
            })
            .addCase(GetSubscriberByPrimaryKey.fulfilled, (state, action) => {
                state.GetSubscriberByPrimaryKeyData.data = action.payload;
            })
            .addCase(GetSubscriberByPrimaryKey.rejected, (state, action) => {
                state.GetSubscriberByPrimaryKeyData.error = action.error.message;
            })
            .addCase(BecomeDeveloper.fulfilled, (state, action) => {
                state.BecomeDeveloperData.data = action.payload;
            })
            .addCase(BecomeDeveloper.rejected, (state, action) => {
                state.BecomeDeveloperData.error = action.error.message;
            })
            .addCase(BecomeClient.fulfilled, (state, action) => {
                state.BecomeClientData.data = action.payload;
            })
            .addCase(BecomeClient.rejected, (state, action) => {
                state.BecomeClientData.error = action.error.message;
            })
            .addCase(SubscriberInviteUser.fulfilled, (state, action) => {
                state.SubscriberInviteUserData.data = action.payload;
            })
            .addCase(SubscriberInviteUser.rejected, (state, action) => {
                state.SubscriberInviteUserData.error = action.error.message;
            })
            .addCase(SubscriberValidateDeActivate.fulfilled, (state, action) => {
                state.SubscriberValidateDeActivateData.data = action.payload;
            })
            .addCase(SubscriberValidateDeActivate.rejected, (state, action) => {
                state.SubscriberValidateDeActivateData.error = action.error.message;
            });
    },
});

export const { setSubscriberIdData } = SubscriberSlice.actions;
export default SubscriberSlice.reducer;
